<template>
    <div class="logo-container">
        <v-img
            class="logo"
            max-width="50%"
            @click="$router.push('/')"
            :lazy-src="require('@/assets/images/logo_lazy.png')"
            :src="require('@/assets/images/logo.png')"
        />
    </div>
</template>

<script>
export default {
    name: 'MainHeader',
}
</script>

<style lang="scss" scoped>
.logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 36px;
    margin-bottom: 36px;
}
.logo {
    cursor: pointer;
}
</style>
